<!--中间显示组件-->
<template>
  <v-content class="v-content">
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-content>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: 'Vuetify Material Dashboard by CreativeTim'
    }
  },
  computed: {}
}
</script>

<style></style>
